import '../../../styles/documents/DocumentsTable.css';
import { MenuButton } from '../../atoms';

export type TableDoc = {
  id: string;
  name: string;
  type: string;
  updated: string;
  documentType?: 'text' | 'doc' | 'ai';
  _raw?: any;
};

type Props = {
  rows: TableDoc[];
  onOpen?: (id: string) => void;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
};

export default function DocumentsTable({ rows, onOpen, onEdit, onDelete }: Props) {

  return (
    <div className="dtbl">
      <div className="dtbl__head">
        <div>Name</div>
        <div>Type</div>
        <div>Last Updated</div>
        <div />
      </div>

      <div>
        {rows.map((r) => {
          const menuItems = [
            {
              label: 'Edit document',
              onClick: () => onEdit?.(r.id),
            },
            {
              label: 'Delete document',
              onClick: () => onDelete?.(r.id),
              danger: true,
            },
          ];

          return (
            <div
              key={r.id}
              className="dtbl__row"
              data-doc-row
              onClick={() => onOpen?.(r.id)}
            >
              <div className="dtbl__cell dtbl__cell--name" title={r.name}>{r.name}</div>
              <div className="dtbl__cell">
                <span className="dtbl__badge">{r.type}</span>
              </div>
              <div className="dtbl__cell dtbl__cell--muted">{r.updated}</div>
              <div className="dtbl__cell dtbl__cell--menu" data-doc-menu onClick={(e) => e.stopPropagation()}>
                <MenuButton menuItems={menuItems} />
              </div>
            </div>
          );
        })}
        {rows.length === 0 && <div className="dtbl__empty">No documents in this filter.</div>}
      </div>
    </div>
  );
}